(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vosper-watch-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) =>
      String(value || "")
        .toLowerCase()
        .replace(/[’']/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();

    const formatDate = (value) => {
      if (!value) return "";
      const parts = value.split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    };

    const formatPrice = (cents, withCurrency = true) => {
      const amount = Number(cents) / 100;
      const value = Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2);
      return `$${value}${withCurrency ? " AUD" : ""}`;
    };

    const braceletFits = {
      "classic": {
        "center": 50,
        "brushedWidth": 89.5,
        "jubilee": { "width": 30.85, "height": 37.02, "top": 275, "bottom": 510 },
        "polished": { "width": 28.65, "height": 34.38, "top": 244, "bottom": 543 }
      },
      "diver": {
        "center": 50,
        "brushedWidth": 93,
        "jubilee": { "width": 31.55, "height": 37.86, "top": 290, "bottom": 507 },
        "polished": { "width": 29.2, "height": 35.04, "top": 257, "bottom": 541 }
      }
    };


    const optionKey = (name) => {
      const key = normalise(name);
      if (key.includes("case")) return "case";
      if (key.includes("dial")) return "dial";
      if (key.includes("bracelet") || key.includes("strap") || key.includes("band")) return "bracelet";
      return "";
    };

    const initialise = (container = document) => {
      if (!globalThis.VosperWatchOrder) {
        const helperScript = document.querySelector("[data-vwb-order-script]");
        const reportLoadError = () => container.querySelectorAll("[data-vosper-builder]").forEach((root) => {
          root.querySelector("[data-vwb-preview-status]").textContent = root.dataset.builderLoadErrorLabel;
          root.querySelectorAll("button").forEach((button) => { button.disabled = true; });
        });
        if (helperScript) {
          helperScript.addEventListener("load", () => initialise(container), { once: true });
          helperScript.addEventListener("error", reportLoadError, { once: true });
        } else reportLoadError();
        return;
      }
      const { getWatchOrderPlan, upsertWatch, removeWatch } = globalThis.VosperWatchOrder;
      container.querySelectorAll("[data-vosper-builder]").forEach((root) => {
        if (root.dataset.vwbReady === "true") return;

        root
          .querySelectorAll(
            "[data-vwb-legacy-options] input, [data-vwb-legacy-summary] input, [data-vwb-legacy-summary] button",
          )
          .forEach((control) => {
            control.disabled = true;
          });

        const syncAvailableHeight = () => {
          const documentTop = root.getBoundingClientRect().top + window.scrollY;
          const previewBar = document.getElementById("PBarNextFrame")?.getBoundingClientRect();
          const reservedHeight = previewBar && previewBar.width > window.innerWidth * 0.8 && previewBar.height > 0
            ? Math.min(80, previewBar.height) : 0;
          const availableHeight = Math.max(610, window.innerHeight - reservedHeight - documentTop);
          root.style.setProperty("--vwb-available-height", `${availableHeight}px`);
        };
        syncAvailableHeight();
        window.addEventListener("resize", syncAvailableHeight);

        const productData = {};
        root.querySelectorAll("[data-vwb-product]").forEach((node) => {
          try {
            productData[node.dataset.vwbProduct] = JSON.parse(node.textContent);
          } catch {
            productData[node.dataset.vwbProduct] = null;
          }
        });

        const form = root.querySelector("[data-vwb-form]");
        const watch = root.querySelector("[data-vwb-watch]");
        const personalisationToggle = root.querySelector("[data-vwb-personalisation-toggle]");
        const personalisationFields = root.querySelector("[data-vwb-personalisation-fields]");
        const personalisationHint = root.querySelector("[data-vwb-personalisation-hint]");
        const wordingInput = root.querySelector("[data-vwb-wording]");
        const dateInput = root.querySelector("[data-vwb-date]");
        const confirmInput = root.querySelector("[data-vwb-confirm]");
        const addButton = root.querySelector("[data-vwb-add]");
        const message = root.querySelector("[data-vwb-message]");
        const variantInput = root.querySelector("[data-vwb-variant-id]");
        const price = root.querySelector("[data-vwb-price]");
        const headingPrice = root.querySelector("[data-vwb-heading-price]");
        const previewWording = root.querySelector("[data-vwb-preview-wording]");
        const previewDate = root.querySelector("[data-vwb-preview-date]");
        const previewCopy = root.querySelector("[data-vwb-dial-copy]");
        const brand = root.querySelector("[data-vwb-brand]");
        const hands = root.querySelector("[data-vwb-hands]");
        const dateWheel = root.querySelector("[data-vwb-date-wheel]");
        const bezelPreview = root.querySelector("[data-vwb-bezel-preview]");
        const characterCount = root.querySelector("[data-vwb-character-count]");
        const previewStatus = root.querySelector("[data-vwb-preview-status]");
        const stepPanels = Array.from(root.querySelectorAll("[data-vwb-step-panel]"));
        const progressItems = Array.from(root.querySelectorAll("[data-vwb-progress-step]"));
        const casePanel = root.querySelector('[data-vwb-step-panel="2"]');
        const caseStagePanels = Array.from(root.querySelectorAll("[data-vwb-case-stage]"));
        const caseHeadings = Array.from(root.querySelectorAll("[data-vwb-case-heading]"));
        const caseContinueButton = root.querySelector("[data-vwb-case-continue]");
        const caseBackButton = root.querySelector("[data-vwb-case-back]");
        const caseTitle = root.querySelector("[data-vwb-case-title]");
        const caseHelp = root.querySelector("[data-vwb-case-help]");
        const sizeContinueButton = root.querySelector("[data-vwb-size-continue]");
        const submarinerStyleButton = root.querySelector("[data-vwb-submariner-style]");
        const dialContinueButton = root.querySelector('[data-vwb-next="4"]');
        const finaliseContinueButton = root.querySelector("[data-vwb-finalise-continue]");
        const orderList = root.querySelector("[data-vwb-order-watch-list]");
        const addAnotherButton = root.querySelector("[data-vwb-add-another-watch]");
        const orderContext = root.querySelector("[data-vwb-order-context]");
        const orderContextCopy = root.querySelector("[data-vwb-order-context-copy]");
        const cancelChangesButtons = root.querySelectorAll("[data-vwb-cancel-changes]");
        const reviewCartLink = root.querySelector("[data-vwb-review-cart]");
        let currentStep = 1;
        let furthestStep = 1;
        let caseStage = "style";
        let cartItems = [];
        let orderWatches = [];
        let activeWatchId = crypto.randomUUID();
        let isSubmitting = false;
        let submissionLocked = false;
        let currentOrderPlan = null;

        const selected = (key) =>
          root.querySelector(`[data-vwb-option="${key}"]:checked:not(:disabled)`);

        const syncCaseControls = () => {
          const size = selected("size")?.value || "mens";
          const caseOption = selected("case");
          const isSubmariner = caseOption?.dataset.style === "diver";

          if (caseTitle) {
            caseTitle.textContent = size === "ladies" ? root.dataset.caseTitleLadies : root.dataset.caseTitleMens;
          }
          if (caseHelp) {
            caseHelp.textContent = size === "ladies" ? root.dataset.caseHelpLadies : root.dataset.caseHelpMens;
          }

          if (submarinerStyleButton) {
            submarinerStyleButton.hidden = size !== "mens";
            submarinerStyleButton.setAttribute("aria-pressed", String(size === "mens" && isSubmariner));
          }

          if (caseContinueButton) {
            caseContinueButton.textContent =
              caseStage === "style" && isSubmariner
                ? caseContinueButton.dataset.continueBezelLabel
                : caseContinueButton.dataset.continueDialLabel;
          }
        };

        const syncProgress = () => {
          progressItems.forEach((item) => {
            const itemStep = Number(item.dataset.vwbProgressStep);
            const button = item.querySelector("[data-vwb-progress-button]");
            const isCurrent = itemStep === currentStep;
            item.classList.toggle("is-current", isCurrent);
            item.classList.toggle("is-complete", itemStep < currentStep);
            if (button) {
              button.disabled = itemStep > furthestStep || isSubmitting || submissionLocked;
              if (isCurrent) button.setAttribute("aria-current", "step");
              else button.removeAttribute("aria-current");
            }
          });
        };

        const lockProgressAfter = (step) => {
          furthestStep = Math.min(furthestStep, step);
          syncProgress();
        };

        const focusActiveHeading = () => {
          const activePanel = root.querySelector(`[data-vwb-step-panel="${currentStep}"]`);
          const heading =
            currentStep === 2
              ? root.querySelector(`[data-vwb-case-heading="${caseStage}"] h2`)
              : activePanel?.querySelector("h2");
          window.requestAnimationFrame(() => heading?.focus({ preventScroll: true }));
        };

        const setCaseStage = (stage, { focus = false } = {}) => {
          const size = selected("size")?.value || "mens";
          caseStage = stage === "bezel" && size === "mens" ? "bezel" : "style";

          caseStagePanels.forEach((panel) => {
            panel.hidden = panel.dataset.vwbCaseStage !== caseStage;
          });

          caseHeadings.forEach((heading) => {
            heading.hidden = heading.dataset.vwbCaseHeading !== caseStage;
          });

          if (casePanel) {
            casePanel.setAttribute(
              "aria-labelledby",
              caseStage === "bezel"
                ? `vwb-step-bezel-${root.dataset.sectionId}`
                : `vwb-step-case-${root.dataset.sectionId}`,
            );
          }

          syncCaseControls();
          syncAvailableHeight();
          if (focus) focusActiveHeading();
        };

        const showStep = (step, { advance = false, focus = false } = {}) => {
          if (isSubmitting || submissionLocked) return;
          const requestedStep = Math.min(5, Math.max(1, Number(step) || 1));
          if (advance) furthestStep = Math.max(furthestStep, requestedStep);
          if (requestedStep > furthestStep) return;
          if (requestedStep === 5) {
            if (personalisationToggle.checked && !Boolean(wordingInput.value.trim() || dateInput.value)) return;
            orderWatches = upsertWatch(orderWatches, captureWatch());
            confirmInput.checked = false;
          }
          if (requestedStep === 2) setCaseStage("style");
          currentStep = requestedStep;
          root.classList.toggle("is-finalising", currentStep === 5);

          stepPanels.forEach((panel) => {
            panel.hidden = Number(panel.dataset.vwbStepPanel) !== currentStep;
          });

          syncProgress();
          render();
          syncAvailableHeight();
          if (focus) focusActiveHeading();
        };

        const setProperty = (key, value) => {
          const input = root.querySelector(`[data-vwb-property="${key}"]`);
          if (input) input.value = value;
        };

        const findVariant = (size, labels) => {
          const product = productData[size];
          if (!product || !Array.isArray(product.options) || !Array.isArray(product.variants)) return null;
          return (
            product.variants.find((variant) =>
              product.options.every((name, index) => {
                const key = optionKey(name);
                return key && normalise(variant.options[index]) === normalise(labels[key]);
              }),
            ) || null
          );
        };

        const syncAudienceOptions = (audience) => {
          let firstAvailableCase = null;
          root.querySelectorAll('[data-vwb-option="case"]').forEach((input) => {
            if (input.closest("[data-vwb-legacy-options]")) return;
            const available = input.dataset.audience === audience;
            const choice = input.closest("[data-vwb-case-audience]");
            input.disabled = !available;
            if (choice) choice.hidden = !available;
            if (available && !firstAvailableCase) firstAvailableCase = input;
          });

          const currentCase = selected("case");
          if ((!currentCase || currentCase.disabled) && firstAvailableCase) {
            firstAvailableCase.checked = true;
          }

          root.querySelectorAll('[data-vwb-option="dial"]').forEach((input) => {
            if (input.closest("[data-vwb-legacy-options]")) return;
            const label = input.dataset[`${audience}Label`] || "";
            const image = input.dataset[`${audience}Image`] || "";
            const dark = input.dataset[`${audience}Dark`] || "false";
            input.dataset.label = label;
            input.dataset.image = image;
            input.dataset.dark = dark;

            const choice = input.closest(".vwb__dial-choice");
            const swatch = choice?.querySelector("[data-vwb-dial-swatch]");
            const text = choice?.querySelector("[data-vwb-dial-label]");
            if (swatch && image) swatch.src = image;
            if (text) text.textContent = label;
          });
        };

        const captureWatch = () => {
          const sizeOption = selected("size");
          const size = sizeOption?.value || "mens";
          const caseOption = selected("case");
          const dialOption = selected("dial");
          const braceletOption = selected("bracelet");
          const wording = wordingInput.value.trim().toUpperCase();
          const dialDate = dateInput.value;
          const enabled = personalisationToggle.checked;
          const labels = { case: caseOption?.dataset.label || "", dial: dialOption?.dataset.label || "", bracelet: braceletOption?.dataset.label || "" };
          const variant = findVariant(size, labels);
          const sizeLabel = `${sizeOption?.dataset.label || ""} · ${caseOption?.dataset.detail || ""}`;
          const properties = {
            _builder_version: "vosper-v7",
            [root.querySelector('[data-vwb-property="size"]').name.match(/^properties\[(.+)\]$/)[1]]: sizeLabel,
            [root.querySelector('[data-vwb-property="personalisation"]').name.match(/^properties\[(.+)\]$/)[1]]: enabled ? root.dataset.personalisationAddedLabel : root.dataset.noneLabel,
          };
          const key = enabled ? globalThis.VosperWatchOrder.getPersonalisationKey(wording, dialDate) : "";
          if (key) properties._personalisation_key = key;
          if (enabled && wording) properties[root.dataset.wordingProperty] = wording;
          if (enabled && dialDate) properties[root.dataset.dateProperty] = formatDate(dialDate);
          return {
            id: activeWatchId, size, caseValue: caseOption?.value, dialValue: dialOption?.value, braceletValue: braceletOption?.value,
            personalisationEnabled: enabled, personalisationKey: key, wording, dialDate, properties,
            sizeLabel, caseLabel: labels.case, dialLabel: labels.dial, braceletLabel: labels.bracelet,
            dialImage: dialOption?.dataset.image || "", variantId: variant?.available ? variant.id : null,
            basePriceCents: Number(variant?.priceCents) || Number(root.dataset.basePriceCents) || 42900,
          };
        };

        const pricingOptions = (items = cartItems) => ({
          cartItems: items, setupFeeVariantId: root.dataset.setupFeeVariantId,
          additionalFeeVariantId: root.dataset.additionalFeeVariantId,
          setupPriceCents: Number(root.dataset.personalisationPriceCents) || 4500,
          additionalPriceCents: Number(root.dataset.additionalPersonalisationPriceCents) || 2000,
          wordingProperty: root.dataset.wordingProperty, dateProperty: root.dataset.dateProperty,
          feeLineLabel: root.dataset.feeLineLabel, setupFeeValue: root.dataset.setupFeeValue,
          additionalFeeValue: root.dataset.additionalFeeValue,
        });

        const currentWatches = () => upsertWatch(orderWatches, captureWatch());

        const restoreWatch = (configuration, step = 2) => {
          activeWatchId = configuration.id;
          const choose = (key, value) => root.querySelectorAll(`[data-vwb-step-panel] [data-vwb-option="${key}"]`).forEach((input) => { input.checked = input.value === value; });
          choose("size", configuration.size);
          syncAudienceOptions(configuration.size);
          choose("case", configuration.caseValue);
          choose("dial", configuration.dialValue);
          choose("bracelet", configuration.braceletValue);
          personalisationToggle.checked = configuration.personalisationEnabled;
          wordingInput.value = configuration.wording;
          dateInput.value = configuration.dialDate;
          confirmInput.checked = false;
          setCaseStage("style");
          furthestStep = 5;
          showStep(step, { focus: true });
        };

        const renderOrderList = (plan) => {
          orderList.replaceChildren();
          plan.entries.forEach(({ watch: configuration, totalPriceCents, alreadyInCart }, index) => {
            const row = document.createElement("li");
            row.className = `vwb__order-watch-card${configuration.id === activeWatchId ? " is-previewed" : ""}`;
            const image = document.createElement("img");
            image.src = configuration.dialImage;
            image.alt = "";
            const copy = document.createElement("div");
            copy.className = "vwb__order-watch-copy";
            const title = document.createElement("h3");
            title.textContent = root.dataset.watchNumberLabel.replace("[number]", String(index + 1));
            const sizeLabel = document.createElement("span");
            sizeLabel.textContent = configuration.sizeLabel;
            title.append(sizeLabel);
            copy.append(title);
            [configuration.caseLabel, `${configuration.dialLabel} · ${configuration.braceletLabel}`, configuration.personalisationEnabled ? [configuration.wording, formatDate(configuration.dialDate)].filter(Boolean).join(" · ") : root.dataset.noCustomTextLabel].forEach((text) => {
              const paragraph = document.createElement("p");
              paragraph.textContent = text;
              copy.append(paragraph);
            });
            const controls = document.createElement("div");
            controls.className = "vwb__order-watch-controls";
            const linePrice = document.createElement("strong");
            linePrice.textContent = alreadyInCart ? root.dataset.inCartLabel : formatPrice(totalPriceCents);
            const buttons = document.createElement("div");
            ["preview", "edit", "remove"].forEach((action) => {
              const button = document.createElement("button");
              button.type = "button";
              button.dataset.vwbWatchAction = action;
              button.dataset.vwbWatchId = configuration.id;
              button.textContent = root.dataset[`${action}Label`];
              button.setAttribute("aria-label", root.dataset[`${action}WatchLabel`].replace("[number]", String(index + 1)));
              if (action === "preview") button.setAttribute("aria-pressed", String(configuration.id === activeWatchId));
              button.disabled = submissionLocked || (action === "remove" && plan.entries.length < 2);
              buttons.append(button);
            });
            controls.append(linePrice, buttons);
            row.append(image, copy, controls);
            orderList.append(row);
          });
        };

        const render = () => {
          const sizeOption = selected("size");
          const size = sizeOption?.value || "mens";
          syncAudienceOptions(size);
          const caseOption = selected("case");
          const dialOption = selected("dial");
          const braceletOption = selected("bracelet");
          const labels = {
            size: sizeOption?.dataset.label || "",
            case: caseOption?.dataset.label || "",
            dial: dialOption?.dataset.label || "",
            bracelet: braceletOption?.dataset.label || "",
          };
          const wording = wordingInput.value.trim().toUpperCase();
          const dialDate = formatDate(dateInput.value);
          const personalisationEnabled = personalisationToggle.checked;
          const personalisationComplete = !personalisationEnabled || Boolean(wording || dateInput.value);
          const setupFeeVariantId = root.dataset.setupFeeVariantId || "";
          const additionalFeeVariantId = root.dataset.additionalFeeVariantId || "";
          const feeAvailable = Boolean(setupFeeVariantId && additionalFeeVariantId);
          const feeKey = personalisationEnabled ? globalThis.VosperWatchOrder.getPersonalisationKey(wording, dateInput.value) : "";
          const none = root.dataset.noneLabel;
          const darkDial = dialOption?.dataset.dark === "true";
          const caseDetail = caseOption?.dataset.detail || sizeOption?.dataset.detail || "";
          const caseMaterial = caseOption?.dataset.material || labels.case;
          const sizeLabel = `${labels.size} · ${caseDetail}`;

          syncCaseControls();

          const braceletLayer = root.querySelector('[data-vwb-layer="bracelet"]');
          const caseLayer = root.querySelector('[data-vwb-layer="case"]');
          const dialLayer = root.querySelector('[data-vwb-layer="dial"]');
          if (braceletOption?.dataset.image) braceletLayer.src = braceletOption.dataset.image;
          const suppliedBracelet = true;
          const braceletLayout = braceletFits[caseOption?.dataset.style === "diver" ? "diver" : "classic"];
          const braceletKind = braceletOption?.value === "bracelet-two" ? "jubilee" : "polished";
          const braceletFit = braceletLayout[braceletKind];
          watch.style.setProperty("--vwb-strap-center", `${braceletLayout.center}%`);
          watch.style.setProperty("--vwb-brushed-width", `${braceletLayout.brushedWidth}%`);
          watch.style.setProperty("--vwb-strap-width", `${braceletFit.width}%`);
          watch.style.setProperty("--vwb-strap-height", `${braceletFit.height}%`);
          braceletLayer.hidden = suppliedBracelet;
          root.querySelectorAll("[data-vwb-strap-half]").forEach((half) => {
            half.toggleAttribute("hidden", !suppliedBracelet);
            half.setAttribute("viewBox", `600 ${braceletFit[half.dataset.vwbStrapHalf]} 250 300`);
            half.querySelector("image").setAttribute("href", braceletOption?.dataset.image || "");
            const kind = braceletOption?.value === "bracelet-two" ? "jubilee" : "polished";
            half.querySelector("image").setAttribute("clip-path", `url(#vwb-strap-${kind}-${half.dataset.vwbStrapHalf}-${root.dataset.sectionId})`);
          });
          if (caseOption?.dataset.image) caseLayer.src = caseOption.dataset.image;
          if (dialOption?.dataset.image) dialLayer.src = dialOption.dataset.image;

          watch.classList.toggle("is-ladies", size === "ladies");
          watch.classList.toggle("is-36mm", caseOption?.value === "case-36");
          watch.classList.toggle("is-diver", caseOption?.dataset.style === "diver");
          if (bezelPreview) {
            const showConceptBezel =
              caseOption?.dataset.style === "diver" &&
              caseOption?.value !== "sub-40-black" &&
              caseOption?.dataset.conceptBezel === "true";
            bezelPreview.hidden = !showConceptBezel;
            bezelPreview.style.setProperty(
              "--vwb-bezel-color",
              caseOption?.dataset.bezelColor || "#161616",
            );
          }
          hands.hidden = size !== "mens";
          dateWheel.hidden = size !== "mens";
          previewCopy.classList.toggle("vwb__dial-copy--light", darkDial);
          previewCopy.classList.toggle("vwb__dial-copy--dark", !darkDial);
          brand.classList.toggle("vwb__brand--light", darkDial);
          brand.classList.toggle("vwb__brand--dark", !darkDial);
          personalisationFields.hidden = !personalisationEnabled;
          wordingInput.disabled = !personalisationEnabled;
          dateInput.disabled = !personalisationEnabled;
          personalisationHint.hidden = personalisationComplete;
          previewCopy.hidden = !personalisationEnabled || !Boolean(wording || dialDate);
          previewWording.textContent = wording;
          previewWording.hidden = !wording;
          previewDate.textContent = dialDate;
          previewDate.hidden = !dialDate;
          characterCount.textContent = String(wording.length);

          root.querySelector('[data-vwb-summary="size"]').textContent = sizeLabel;
          root.querySelector('[data-vwb-summary="case"]').textContent = caseMaterial;
          root.querySelector('[data-vwb-summary="dial"]').textContent = labels.dial;
          root.querySelector('[data-vwb-summary="bracelet"]').textContent = labels.bracelet;
          root.querySelector('[data-vwb-summary="personalisation"]').textContent = personalisationEnabled
            ? root.dataset.personalisationAddedLabel
            : none;
          root.querySelector('[data-vwb-summary="wording"]').textContent =
            personalisationEnabled ? wording || none : none;
          root.querySelector('[data-vwb-summary="date"]').textContent =
            personalisationEnabled ? dialDate || none : none;

          setProperty(
            "personalisation",
            personalisationEnabled ? root.dataset.personalisationAddedLabel : none,
          );
          setProperty("size", sizeLabel);
          setProperty("case", labels.case);
          setProperty("dial", labels.dial);
          setProperty("bracelet", labels.bracelet);
          setProperty("wording", personalisationEnabled ? wording : "");
          setProperty("date", personalisationEnabled ? dialDate : "");
          setProperty("personalisation_key", feeKey);

          const variant = findVariant(size, labels);
          const product = productData[size];
          const usableVariant = variant && variant.available ? variant : null;
          const fallbackBasePrice = Number(root.dataset.basePriceCents) || 42900;
          const basePrice = Number(usableVariant?.priceCents) || fallbackBasePrice;
          const setupPrice = Number(root.dataset.personalisationPriceCents) || 4500;
          const configurations = currentWatches();
          currentOrderPlan = getWatchOrderPlan({ ...pricingOptions(), watches: configurations.filter((configuration) => !configuration.personalisationEnabled || configuration.personalisationKey) });
          const currentEntry = currentOrderPlan.entries.find((entry) => entry.watch.id === activeWatchId);
          const personalisationPrice = personalisationEnabled ? currentEntry?.personalisationPriceCents ?? setupPrice : setupPrice;
          const addonPrice = root.querySelector("[data-vwb-addon-price]");
          if (addonPrice) addonPrice.textContent = `+${formatPrice(personalisationPrice, false)}`;
          const totalPrice = basePrice + (personalisationEnabled ? personalisationPrice : 0);
          const selectedVariantId = usableVariant ? String(usableVariant.id) : "";
          variantInput.value = selectedVariantId;
          form.dataset.vwbVariantId = selectedVariantId;
          price.textContent = formatPrice(currentOrderPlan.totalPriceCents);
          if (headingPrice) headingPrice.textContent = formatPrice(currentStep === 5 ? currentOrderPlan.totalPriceCents : totalPrice);
          root.querySelector("[data-vwb-order-base]").textContent = `${configurations.length} · ${formatPrice(currentOrderPlan.basePriceCents)}`;
          root.querySelector("[data-vwb-order-fees]").textContent = formatPrice(currentOrderPlan.personalisationPriceCents);
          root.querySelector("[data-vwb-order-title]").textContent = submissionLocked ? root.dataset.remainingToAddLabel : root.dataset.yourOrderLabel;
          const unavailableSavedWatch = configurations.some((configuration) => !configuration.variantId);
          addButton.disabled =
            currentStep !== 5 || isSubmitting || unavailableSavedWatch ||
            !confirmInput.checked ||
            !personalisationComplete ||
            (configurations.some((configuration) => configuration.personalisationEnabled) && !feeAvailable);
          if (dialContinueButton) dialContinueButton.disabled = !personalisationComplete;
          addButton.textContent = isSubmitting ? root.dataset.addingLabel : submissionLocked ? root.dataset.retryRemainingLabel : root.dataset.addLabel;
          addAnotherButton.disabled = submissionLocked || isSubmitting;
          root.querySelector('[data-vwb-step-panel="5"] [data-vwb-back]').disabled = submissionLocked;
          reviewCartLink.hidden = !submissionLocked;
          orderContext.hidden = !orderWatches.length || currentStep === 5;
          cancelChangesButtons.forEach((button) => {
            button.hidden = !orderWatches.length || currentStep === 5;
            button.disabled = isSubmitting || submissionLocked;
          });
          orderContextCopy.textContent = `${orderWatches.some((configuration) => configuration.id === activeWatchId) ? root.dataset.editingWatchLabel : root.dataset.designingWatchLabel.replace("[number]", String(orderWatches.length + 1))} · ${root.dataset.savedWatchesLabel.replace("[count]", String(orderWatches.length))}`;
          if (currentStep === 5) renderOrderList(currentOrderPlan);

          if (!product) {
            message.textContent = root.dataset.unavailableLabel;
          } else if (unavailableSavedWatch && currentStep === 5) {
            message.textContent = root.dataset.orderUnavailableLabel;
          } else if (!usableVariant) {
            message.textContent = root.dataset.selectionUnavailableLabel;
          } else if (!personalisationComplete) {
            message.textContent = root.dataset.personalisationRequiredLabel;
          } else if (configurations.some((configuration) => configuration.personalisationEnabled) && !feeAvailable) {
            message.textContent = root.dataset.feeUnavailableLabel;
          } else {
            message.textContent = "";
          }

          previewStatus.textContent =
            `${sizeLabel}, ${labels.case}, ${labels.dial}, ${labels.bracelet}, ${personalisationEnabled ? root.dataset.personalisationAddedLabel : none}, ${personalisationEnabled ? wording || none : none}, ${personalisationEnabled ? dialDate || none : none}`;
        };

        const renderWithTransition = () => {
          render();
        };

        const refreshCart = async () => {
          if (isSubmitting) return;
          const shopRoot = window.Shopify?.routes?.root;
          if (!shopRoot) return;

          try {
            const response = await fetch(`${shopRoot}cart.js`, {
              headers: { Accept: "application/json" },
            });
            if (!response.ok) return;
            const cart = await response.json();
            cartItems = Array.isArray(cart?.items) ? cart.items : [];
            render();
          } catch {
            cartItems = [];
          }
        };

        root.querySelectorAll("[data-vwb-step-panel] [data-vwb-option]").forEach((input) => {
          input.addEventListener("change", () => {
            confirmInput.checked = false;
            const optionStep = { size: 1, case: 2, dial: 3, bracelet: 4 }[input.dataset.vwbOption];
            if (optionStep) lockProgressAfter(optionStep);
            if (input.dataset.vwbOption === "size") setCaseStage("style");
            renderWithTransition();
          });

        });

        if (sizeContinueButton) {
          sizeContinueButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            render();
            showStep(2, { advance: true, focus: true });
          });
        }

        root.querySelectorAll("[data-vwb-progress-button]").forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            showStep(button.dataset.vwbProgressButton, { focus: true });
          });
        });

        root.querySelectorAll("[data-vwb-back]").forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            showStep(button.dataset.vwbBack, { focus: true });
          });
        });

        if (submarinerStyleButton) {
          submarinerStyleButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            const currentCase = selected("case");
            const blackBezel = root.querySelector(
              '[data-vwb-option="case"][value="sub-40-black"]',
            );
            if (currentCase?.dataset.style !== "diver" && blackBezel && !blackBezel.disabled) {
              blackBezel.checked = true;
            }
            lockProgressAfter(2);
            confirmInput.checked = false;
            renderWithTransition();
          });
        }

        if (caseBackButton) {
          caseBackButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (caseStage === "bezel") setCaseStage("style", { focus: true });
            else showStep(1, { focus: true });
          });
        }

        if (caseContinueButton) {
          caseContinueButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            render();
            const caseOption = selected("case");
            if (caseStage === "style" && caseOption?.dataset.style === "diver") {
              setCaseStage("bezel", { focus: true });
              return;
            }
            showStep(3, { advance: true, focus: true });
          });
        }

        if (dialContinueButton) {
          dialContinueButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            render();
            if (!dialContinueButton.disabled) showStep(4, { advance: true, focus: true });
          });
        }

        finaliseContinueButton.addEventListener("click", () => {
          render();
          showStep(5, { advance: true, focus: true });
        });

        addAnotherButton.addEventListener("click", () => {
          if (isSubmitting || submissionLocked) return;
          orderWatches = currentWatches();
          restoreWatch({ id: crypto.randomUUID(), size: "mens", caseValue: "case-39", dialValue: "dial-one", braceletValue: "bracelet-one", personalisationEnabled: false, wording: "", dialDate: "" }, 1);
          furthestStep = 1;
          syncProgress();
        });

        cancelChangesButtons.forEach((button) => {
          button.addEventListener("click", () => {
            if (isSubmitting || submissionLocked) return;
            const original = orderWatches.find((configuration) => configuration.id === activeWatchId) || orderWatches.at(-1);
            if (original) restoreWatch(original, 5);
          });
        });

        orderList.addEventListener("click", (event) => {
          if (isSubmitting || submissionLocked) return;
          const button = event.target.closest("[data-vwb-watch-action]");
          if (!button || button.disabled) return;
          const configurations = currentWatches();
          const configuration = configurations.find((item) => item.id === button.dataset.vwbWatchId);
          if (!configuration) return;
          if (button.dataset.vwbWatchAction === "preview") {
            const wasConfirmed = confirmInput.checked;
            restoreWatch(configuration, 5);
            confirmInput.checked = wasConfirmed;
            render();
          } else if (button.dataset.vwbWatchAction === "edit") {
            orderWatches = configurations;
            restoreWatch(configuration);
          } else if (configurations.length > 1) {
            orderWatches = removeWatch(configurations, configuration.id);
            confirmInput.checked = false;
            if (configuration.id === activeWatchId) restoreWatch(orderWatches.at(-1), 5);
            else render();
            focusActiveHeading();
          }
        });

        personalisationToggle.addEventListener("change", () => {
          lockProgressAfter(3);
          confirmInput.checked = false;
          renderWithTransition();
        });

        wordingInput.addEventListener("input", () => {
          wordingInput.value = wordingInput.value.toUpperCase();
          lockProgressAfter(3);
          confirmInput.checked = false;
          render();
        });

        dateInput.addEventListener("input", () => {
          lockProgressAfter(3);
          confirmInput.checked = false;
          render();
        });

        confirmInput.addEventListener("change", render);

        form.addEventListener("submit", async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (currentStep !== 5 || isSubmitting) return;
          render();
          if (addButton.disabled) return;

          const configurations = currentWatches();
          const reviewedTotal = currentOrderPlan.totalPriceCents;
          isSubmitting = true;
          form.inert = true;
          syncProgress();
          addButton.disabled = true;
          addButton.textContent = root.dataset.addingLabel;
          message.textContent = "";

          try {
            const shopRoot = window.Shopify?.routes?.root || "/";
            if (configurations.some((configuration) => !configuration.variantId)) throw new Error("variant-missing");
            const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: "application/json" } });
            if (!cartResponse.ok) throw new Error("cart-read-failed");
            const cart = await cartResponse.json();
            if (!Array.isArray(cart?.items)) throw new Error("cart-read-failed");
            cartItems = Array.isArray(cart.items) ? cart.items : [];
            const plan = getWatchOrderPlan({ ...pricingOptions(cartItems), watches: configurations });
            if (plan.totalPriceCents !== reviewedTotal) {
              confirmInput.checked = false;
              throw new Error("total-changed");
            }
            if (plan.items.some((item) => !item.id)) throw new Error("variant-missing");
            submissionLocked = true;
            const addResponse = plan.items.length ? await fetch(`${shopRoot}cart/add.js`, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ items: plan.items }),
            }) : { ok: true };
            if (!addResponse.ok) throw new Error("cart-add-failed");
            const verificationResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: "application/json" } });
            if (!verificationResponse.ok) throw new Error("cart-verification-failed");
            const verifiedCart = await verificationResponse.json();
            if (!Array.isArray(verifiedCart?.items)) throw new Error("cart-verification-failed");
            cartItems = verifiedCart.items;
            if (getWatchOrderPlan({ ...pricingOptions(cartItems), watches: configurations }).items.length) throw new Error("cart-incomplete");
            const cartUrl = new URL(`${shopRoot}cart`, window.location.origin);
            if (window.Shopify?.theme?.role === "unpublished") {
              cartUrl.searchParams.set("preview_theme_id", String(window.Shopify.theme.id));
            }
            window.location.assign(cartUrl.href);
          } catch (error) {
            isSubmitting = false;
            form.inert = false;
            syncProgress();
            render();
            message.textContent = error.message === "total-changed" ? root.dataset.orderTotalChangedLabel : root.dataset.orderCartErrorLabel;
            const cartUrl = new URL(`${window.Shopify?.routes?.root || "/"}cart`, window.location.origin);
            if (window.Shopify?.theme?.role === "unpublished") cartUrl.searchParams.set("preview_theme_id", String(window.Shopify.theme.id));
            reviewCartLink.href = cartUrl.href;
          }
        });

        showStep(1, { advance: true });
        render();
        root.dataset.vwbReady = "true";
        refreshCart();
        window.addEventListener("pageshow", refreshCart);
        window.addEventListener("focus", refreshCart);
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initialise());
    } else {
      initialise();
    }

    document.addEventListener("shopify:section:load", (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
